import { QuestionRevisePage } from "./QuestionRevisePage";
export default QuestionRevisePage;
